import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { completeSignIn } from "@/auth/session";
import { safeNext } from "@/features/access/rules";
import { ErrorState, LoadingState } from "@/components/ui/controls";

/** Where the identity provider returns after sign-in. */
export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    completeSignIn()
      .then((to) => navigate(safeNext(to), { replace: true }))
      .catch(setError);
  }, [navigate]);

  return (
    <div
      style={{ height: "100vh", display: "grid", placeItems: "center", background: "var(--bg)" }}
    >
      {error ? (
        <ErrorState error={error} onRetry={() => window.location.assign("/")} />
      ) : (
        <LoadingState label="Signing you in" />
      )}
    </div>
  );
}
